import { Tag, BtnLink } from "../components/index.js";
import { Icon } from "../components/Icon.js";
import { useSurface } from "../lib/useSurface.js";

/** QR landing — opens the latest published manual for a piece of equipment. */
export function Qr() {
  useSurface("field");

  return (
    <div className="shell">
      <header className="appbar">
        <div className="brand" style={{ fontSize: 17 }}>
          <span className="glyph" aria-hidden="true" />
          TEBIKI
        </div>
        <span className="grow" />
        <Tag mono>QR · 機材ラベル</Tag>
      </header>

      <main className="land" style={landStyle}>
        <div className="qrbox reveal" style={qrboxStyle}>
          <svg viewBox="0 0 100 100" aria-hidden="true" style={{ width: 118, height: 118 }}>
            <rect width="100" height="100" fill="#fff" />
            <g fill="#16171b">
              <rect x="6" y="6" width="24" height="24" />
              <rect x="12" y="12" width="12" height="12" fill="#fff" />
              <rect x="70" y="6" width="24" height="24" />
              <rect x="76" y="12" width="12" height="12" fill="#fff" />
              <rect x="6" y="70" width="24" height="24" />
              <rect x="12" y="76" width="12" height="12" fill="#fff" />
              <rect x="40" y="8" width="6" height="6" />
              <rect x="52" y="8" width="6" height="6" />
              <rect x="40" y="40" width="6" height="6" />
              <rect x="62" y="40" width="6" height="6" />
              <rect x="74" y="44" width="6" height="6" />
              <rect x="56" y="60" width="6" height="6" />
              <rect x="44" y="74" width="6" height="6" />
              <rect x="70" y="74" width="6" height="6" />
            </g>
          </svg>
          <div className="scanline" style={{ position: "absolute", left: 14, right: 14, height: 2, background: "var(--hi)", boxShadow: "0 0 12px var(--hi)", animation: "scan 2.2s var(--ease) infinite" }} />
        </div>
        <div className="kicker reveal d1" style={{ color: "var(--hi)" }}>
          スキャンしました
        </div>
        <h1 className="display t-lg reveal d1 jp">
          コーヒーマシンの
          <br />
          清掃手順
        </h1>
        <div className="row reveal d2" style={{ justifyContent: "center", flexWrap: "wrap" }}>
          <Tag>12 STEPS</Tag>
          <Tag mono>v3 · 公開中</Tag>
          <Tag dot color="var(--ok)">
            最新
          </Tag>
        </div>
        <p className="jp reveal d2" style={{ color: "var(--muted)", maxWidth: 420 }}>
          この機材に貼られたQRから、いつでも最新の手順を開けます。
        </p>
        <BtnLink to="/viewer/m_coffee" variant="hi" lg icon={<Icon name="play" />} className="reveal d3" style={{ minWidth: 240 }}>
          手順を開く
        </BtnLink>
        <button className="btn btn--ghost reveal d3" style={{ color: "var(--muted)" }} disabled aria-disabled="true" title="準備中（表示言語切替）">
          <Icon name="multilingual" size={16} /> 言語を選ぶ
        </button>
      </main>

      <style>{`@keyframes scan{0%{top:18px}50%{top:130px}100%{top:18px}}`}</style>
    </div>
  );
}

const landStyle = {
  flex: 1,
  display: "flex",
  flexDirection: "column",
  alignItems: "center",
  justifyContent: "center",
  textAlign: "center",
  padding: "36px 24px",
  gap: 18,
} as const;
const qrboxStyle = { width: 150, height: 150, borderRadius: 18, background: "#fff", display: "grid", placeItems: "center", position: "relative" } as const;
